import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  jobLocations: [],
  jobLocation: [],
  jobCourtrooms: [],
  jobJurisdictions: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const jobLocationSlice = createSlice({
  name: 'jobLocation',
  initialState: initialState,
  reducers: {
    setJobLocation: (state, { payload }) => {
      state.jobLocations = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setJobLocations: (state, { payload }) => {
      state.jobLocations = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setJobLocationById: (state, { payload }) => {
      state.jobLocation = payload;
    },
    setJobCourtrooms: (state, { payload }) => {
      state.jobCourtrooms = payload;
    },
    setJobJurisdictions: (state, { payload }) => {
      state.jobJurisdictions = payload;
    },
    setMoreJobLocations: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeJobLocation: (state, { payload }) => {
      state.error = payload
    },
    clearAllJobLocation: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addJobLocation = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addJobLocation(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const updateJobLocation = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateJobLocation(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setJobLocation(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeJobLocation = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeJobLocation(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setJobLocation(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const fetchJobLocations = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchJobLocations(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setJobLocations(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setJobLocations(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchJobLocationById = (id, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchJobLocationById(id)
    dispatch(setJobLocationById(result.data.data));
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchJobLocationCourtrooms = (id, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchJobLocationCourtrooms(id)
    dispatch(setJobCourtrooms(result.data.data));
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchJobLocationJurisdictions = (id, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchJobLocationJurisdictions(id)
    dispatch(setJobJurisdictions(result.data.data));
  } catch (error) {
    console.log("error", error)
  }
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, 'job-locations')
    if (json.status >= 200 && json.status < 300) {
    } else if (json.status == 422) {
      dispatch(setError(json.data))
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeMultipleJobLocations = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleJobLocations(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const { setJobLocation,setJobCourtrooms, setJobJurisdictions, setJobLocations,setJobLocationById, clearAllJobLocation, setLoader, setError, setMoreJobLocations } = jobLocationSlice.actions


export default jobLocationSlice.reducer
export const jobLocationSelector = state => state.jobLocation


